module.exports = __webpack_public_path__ + "static/media/wordpress.5dd240bd.png";